var _path, _path2, _g, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsColumna2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 529,
    viewBox: "0 0 343 529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9695 78.0239L104.018 78.0239C115.114 78.0239 124.109 69.0269 124.109 57.9285C124.109 46.8302 115.114 37.8331 104.018 37.8331L20.9695 37.8331C9.87309 37.8331 0.877663 46.8302 0.877663 57.9285C0.877663 69.0269 9.87309 78.0239 20.9695 78.0239Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.935 0H318.198C324.603 0 330.746 2.5447 335.274 7.07428C339.803 11.6039 342.347 17.7473 342.347 24.1531V108.375C342.347 109.452 342.135 110.519 341.722 111.514C341.309 112.509 340.704 113.413 339.941 114.173C339.178 114.934 338.273 115.537 337.277 115.947C336.281 116.357 335.214 116.566 334.137 116.563H252.972C250.801 116.563 248.719 115.7 247.184 114.165C245.648 112.629 244.786 110.547 244.786 108.375V24.1531C244.786 17.7473 247.33 11.6039 251.859 7.07428C256.388 2.5447 262.53 0 268.935 0V0Z",
    fill: "#F2EAE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.956 196.735H14.1342C6.32809 196.735 0 203.065 0 210.872V308.711C0 316.519 6.32809 322.848 14.1342 322.848H111.956C119.762 322.848 126.09 316.519 126.09 308.711V210.872C126.09 203.065 119.762 196.735 111.956 196.735Z",
    fill: "#3098F3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318.899 220.696H273.33C260.02 220.696 249.229 231.488 249.229 244.801V276.973C249.229 290.286 260.02 301.078 273.33 301.078H318.899C332.209 301.078 343 290.286 343 276.973V244.801C343 231.488 332.209 220.696 318.899 220.696Z",
    fill: "#FE6571"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9369 529H62.2564C55.5713 529 48.9517 527.683 42.7755 525.124C36.5994 522.565 30.9875 518.815 26.2605 514.087C21.5335 509.359 17.7838 503.746 15.2255 497.569C12.6672 491.392 11.3505 484.771 11.3505 478.085L11.3505 453.69C11.3505 452.101 11.9815 450.578 13.1046 449.455C14.2278 448.331 15.7511 447.7 17.3394 447.7H109.854C110.642 447.7 111.423 447.856 112.151 448.158C112.879 448.461 113.541 448.904 114.097 449.463C114.654 450.022 115.094 450.685 115.394 451.415C115.693 452.144 115.846 452.926 115.843 453.714L115.843 478.085C115.843 491.588 110.479 504.539 100.933 514.087C91.3861 523.635 78.438 529 64.9369 529V529Z",
    fill: "#FE6571"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.735 464.096H258.895C245.584 464.096 234.794 474.888 234.794 488.201V488.225C234.794 501.537 245.584 512.329 258.895 512.329H318.735C332.046 512.329 342.836 501.537 342.836 488.225V488.201C342.836 474.888 332.046 464.096 318.735 464.096Z",
    fill: "#FFCC00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126.09,
    height: 126.113,
    fill: "white",
    transform: "translate(0 196.735)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColumna2);
export default __webpack_public_path__ + "static/media/icons-columna2.7742418471091b7de78dce2dcec99ce4.svg";
export { ForwardRef as ReactComponent };